/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import browser from 'browser-detect';
import { connect, shallowEqual, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import './apply.scss';
import '../../components/--groups/gr-job-group/gr-job-group.scss';
import queryString from 'query-string';
import PrButton from '../../components/--primitives/pr-button';
import { loadSettings } from '../../redux/actions/settings-actions';
import ResumeReaderMsgModal from './modules/resume-reader-message';
import {
  loadRoute,
  importImagesFromImageDirectory,
  strictValidObjectWithKeys,
  validObjectWithParameterKeys,
  strictValidString,
} from '../../utils/commonUtils';
import {
  Popup,
  PopupBody,
  PopupHeader,
  PopupFooter,
} from '../../components/--primitives/pr-popup';
import validate from './validate';
import Loading from '../../components/--primitives/pr-loading';
import CandidateInfo from './modules/candidate-info';
import {
  registerCandidate,
  readCandidateResume,
  updateResumeFile,
} from './action';

import { messages } from '../../language';
import AlertMsgModal from '../profile/module/alert-msg';
import PrArrowSubmitComponent from '../../components/--primitives/pr-arrow-submit';
import PrimerBlackLogo from '../../components/primer-black-logo-svg';
import PrXMarkComponent from '../../components/--primitives/pr-x-mark';
import packageJson from '../../../package.json';
import { getTimezoneStr } from '../../utils/siteSpecificCommonUtils';
import { timezoneOptions } from '../../utils/siteSpecificConstants';
import { getPathname, signingUrl } from './helpers';
import S3Upload from '../../components/s3-file-uploader/s3-upload';
import { updateCandidateDetails } from '../profile/actions';

const images = importImagesFromImageDirectory(
  require.context('../../assets/logo/', false, /\.(png|jpe?g|svg)$/),
);

const initialState = {
  job_functions: [],
  industries: [],
  primary_resume: {},
};

function Apply({
  isModalOpen,
  // eslint-disable-next-line react/prop-types
  location,
  callLoadSettingsAPI,
  dispatch,
  isLoadSettings,
  internalApplyLoading,
  callRegisterCandidateAPI,
  configLoad,
  tenantConfig = {},
  CallUpdateCandidate,
}) {
  // const config = useSelector((state) => state.config, shallowEqual);
  // const { tenantConfig = {}, isLoad: configLoad } = useMemo(
  //   () => config || { tenantConfig: {}, isLoad: false },
  //   [config],
  // );
  // console.log(config, 'config');
  const [isThankYouModelOpen, setThankYouModelOpen] = useState(false);
  const [{ isOpenWarningPopUp, warningMessage }, setWarningError] = useState({
    isOpenWarningPopUp: false,
    warningMessage: null,
  });
  const [tempResumePath, setTempResumePath] = useState(null);
  const [resumeData, setResumeData] = useState({});
  const [resumeReading, setResumeReading] = useState(false);

  const [thankyouMessage, setThankYouMessage] = useState(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const actionBtns = useRef(null);
  const browserInfo = browser();

  function callLoadSettingsFun() {
    callLoadSettingsAPI(['jobfunctions', 'candidate_hear_about_us']);
  }

  useEffect(() => {
    callLoadSettingsFun();
  }, [isModalOpen]);

  function thankModelFun() {
    return thankyouMessage && setThankYouModelOpen((prevState) => !prevState);
  }

  useEffect(() => {
    thankModelFun();
  }, [thankyouMessage]);

  const getTimezone = (tz) => {
    const existTz = timezoneOptions.find((item) => item.value === tz);
    if (existTz) return tz;
    const timeZone = getTimezoneStr(tz);
    let selectedTimezone = timezoneOptions.find(
      (item) => item.label === timeZone,
    );
    if (!selectedTimezone) {
      selectedTimezone = timezoneOptions.find((item) => item.label === 'PST');
    }
    return selectedTimezone && selectedTimezone.value;
  };

  const successMessage = (res) => {
    if (validObjectWithParameterKeys(res, ['info', 'message']))
      setThankYouMessage(res.message);
    else if (res) {
      setThankYouMessage(messages.APPLY_PROCESS_HELPER_TEXT.THANK_YOU_MESSAGE);
    }
  };

  const onUploadUser = async (type, val, res) => {
    const {
      user: { token },
    } = res;
    let UpdateData = { token, is_pending: true };
    if (type === 'error') {
      let err;
      try {
        const errorObject = JSON.parse(val);
        err = `${errorObject.message} - ${errorObject.processId}`;
      } catch {
        err = val;
      }
      UpdateData = {
        ...UpdateData,
        upload_resume_error: true,
        s3_error: err,
      };
    } else {
      const { data } = val;
      UpdateData = { ...UpdateData, primary_resume: data.split('?')[0] };
    }
    await CallUpdateCandidate(UpdateData);
    successMessage(res);
  };

  const onSubmit = async (values) => {
    const {
      job_functions,
      // industries,
      linkedin_url,
      address,
      user: {
        first_name,
        middle_name,
        last_name,
        email,
        phone,
        source: { value: sourceValue },
        source_text,
      },
      primary_resume,
    } = values;
    const profileData = resumeData.profile ?? {};
    if (profileData) {
      let open_to_remote = 0;
      if (profileData.open_to_remote) {
        open_to_remote = 1;
      }
      profileData.open_to_remote = open_to_remote;
    }
    const preferred_job_locations = [];
    preferred_job_locations.push({
      city: address.city,
      country: address.country,
      county: address.county,
      state: address.state,
      timezone: address.timezone,
      zipcode: address.zipcode,
      location_coordinates: {
        type: 'Point',
        coordinates: strictValidObjectWithKeys(address.coordinates, [
          'lat',
          'lng',
        ])
          ? [address.coordinates.lng, address.coordinates.lat]
          : [],
      },
      proximity: 10, // set default proximity value 10
      relocation_required: false,
    });
    let valuesToSend = {
      profile: {
        interview_timezone_preference: getTimezone(address.timezone),
        ...profileData,
        linkedin_url,
        preferred_job_locations,
        job_functions,
      },
      user: {
        first_name,
        middle_name,
        last_name,
        email,
        phone,
        source: { value: sourceValue },
        source_text,
      },
    };
    let query = {};
    query = queryString.parse(location.search);
    const { job, ...rest } = query;
    if (job) {
      valuesToSend = {
        ...valuesToSend,
        job,
        job_meta_data: {
          ...rest,
        },
      };
    }
    if (!tempResumePath) {
      valuesToSend.profile = {
        ...valuesToSend.profile,
        resume_parsing: 'manual',
      };
    }
    const res = await dispatch(registerCandidate(valuesToSend));

    if (res) {
      successMessage(res);
      if (tempResumePath) {
        const resp = await dispatch(
          updateResumeFile({
            primary_resume: tempResumePath,
            token: res.user.token,
            id: res.user._id,
          }),
        );
        const url = resp;
        if (url) {
          const urlObj = new URL(url);
          const path = urlObj.pathname;
          await dispatch(
            readCandidateResume({
              type: 'profile_data',
              setResumeReading,
              token: res.user.token,
              file_url: path,
            }),
          );
        }
      }
    }
    // const res = await dispatch(registerCandidate(valuesToSend));

    // let valuesToSend = {
    //   profile: {
    //     job_functions,
    //     source: sourceValue,
    //     source_text,
    //     linkedin_url,
    //     preferred_job_locations,
    //     interview_timezone_preference: getTimezone(address.timezone),
    //   },
    //   user: { first_name, middle_name, last_name, email, phone },
    // };
    // let query = {};
    // query = queryString.parse(location.search);
    // const { job, ...rest } = query;
    // if (job) {
    //   valuesToSend = {
    //     ...valuesToSend,
    //     job,
    //     job_meta_data: {
    //       ...rest,
    //     },
    //   };
    // }

    // const res = await callRegisterCandidateAPI(valuesToSend);
    if (res) {
      if (strictValidObjectWithKeys(primary_resume)) {
        try {
          if (validObjectWithParameterKeys(res, ['user', 'profile'])) {
            const { user, profile } = res;
            new S3Upload({
            // eslint-disable-line
              files: [primary_resume],
              signingUrl,
              s3Path: getPathname({ ...user, profile }, 'resume'),
              onProgress: (prog) => setDisableBtn(prog < 100),
              onError: async (err) => await onUploadUser('error', err, res),
              onFinishS3Put: async (val) => await onUploadUser('', val, res),
              uploadRequestHeaders: {},
            });
          } else successMessage(res);
        } catch (e) {
          console.log(e);
        }
      } else successMessage(res);
    }
  };

  return [
    isLoadSettings && <Loading type="overlay" />,
    isOpenWarningPopUp && (
      <Popup className="error-popup" action="error" isOpen={isOpenWarningPopUp}>
        <PopupHeader
          action="error"
          close
          toggle={() => setWarningError({ isOpenWarningPopUp: false })}
        />
        <PopupBody>
          <div className="content title">{warningMessage}</div>
        </PopupBody>
        <PopupFooter>
          <PrButton
            value="Ok"
            type="blue tall"
            onClick={() => setWarningError({ isOpenWarningPopUp: false })}
          />
        </PopupFooter>
      </Popup>
    ),
    <div className="apply-page-wrapper in-view" key="in-view">
      <div
        className="first-side"
        style={{
          backgroundColor: tenantConfig.bg_color
            ? tenantConfig.bg_color
            : '#000611',
        }}
      >
        <div className="absolute-wrapper">
          {/* <div className="corona">
            <PrAnimatedLogo2Component />
          </div> */}
          <div className="logo">
            {/* <img
              src={images['FullLogo_White.png']}
              alt="logo"
              className="outer_logo_image"
            /> */}
            {!configLoad && (
              <img
                src={tenantConfig.logo_white || images['ajna-logo-white.svg']}
                alt="logo"
                className="outer_logo_image"
              />
            )}
          </div>
          <p className="copyright">Version {packageJson.version}</p>
        </div>
      </div>
      <div className="second-side">
        <div className="header">
          <div className="responsive-logo">
            {!configLoad && tenantConfig.logo_black ? (
              <img
                src={tenantConfig.logo_black}
                alt="logo"
                className="mob_outer_logo_image"
              />
            ) : (
              <PrimerBlackLogo />
            )}
          </div>
          <PrXMarkComponent onClick={() => loadRoute(dispatch)} />
        </div>
        {/* <ErrorModal
          key="error-modal"
          isOpen={errorModalMessage !== null}
          message={errorModalMessage}
          onClose={() => setErrorModalMessage(null)}
        /> */}
        <AlertMsgModal
          message={thankyouMessage}
          isOpen={isThankYouModelOpen}
          toggle={() => {
            setThankYouModelOpen(false);
            loadRoute(dispatch);
          }}
        />
        <ResumeReaderMsgModal
          message="We’re parsing your resume. Please allow a few moments for the upload to complete."
          isOpen={resumeReading}
          toggle={() => {
            setResumeReading(false);
            loadRoute(dispatch);
          }}
        />
        <div className="forms-wrapper">
          <Form
            onSubmit={onSubmit}
            mutators={{
              ...arrayMutators,
            }}
            initialValues={initialState}
            validate={(values) => validate(values)}
            render={({ handleSubmit, form, pristine, hasValidationErrors }) => {
              form;
              return (
                <form
                  className={`apply-process-screens ${browserInfo.name}`}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="page-wrapper apply-details">
                    <div className="content-wrapper">
                      <CandidateInfo
                        form={form}
                        type="apply"
                        dropDownRef={actionBtns}
                        setResumeReading={setResumeReading}
                        setTempResumePath={setTempResumePath}
                        setResumeData={setResumeData}
                      />
                    </div>
                    <div className="row">
                      <span className="pr-arrow-submit-wrapper">
                        <p>Submit</p>
                        <PrArrowSubmitComponent
                          onClick={handleSubmit}
                          isLoading={internalApplyLoading || disableBtn}
                          type={
                            internalApplyLoading ||
                            pristine ||
                            hasValidationErrors ||
                            disableBtn
                              ? 'relative large right disable-2'
                              : 'relative large right'
                          }
                        />
                      </span>
                    </div>
                  </div>
                </form>
              );
            }}
          />
        </div>
      </div>
    </div>,
  ];
}

Apply.propTypes = {
  dispatch: PropTypes.func.isRequired,
  callLoadSettingsAPI: PropTypes.func.isRequired,
  isLoadSettings: PropTypes.bool,
  internalApplyLoading: PropTypes.bool,
  isModalOpen: PropTypes.bool,
  callRegisterCandidateAPI: PropTypes.func.isRequired,
  tenantConfig: PropTypes.shape(PropTypes.object),
  configLoad: PropTypes.bool,
  CallUpdateCandidate: PropTypes.func.isRequired,
};

Apply.defaultProps = {
  isLoadSettings: false,
  internalApplyLoading: false,
  isModalOpen: true,
  tenantConfig: {},
  configLoad: false,
};

const mapStateProps = (state) => {
  return {
    user: state.get('auth').get('user'),
    isLoadSettings: state.get('settings').get('isLoad'),
    internalApplyLoading:
      state.get('apply').get('isLoad') ||
      state.get('profile').get('isEditLoad'),
    tenantConfig: state.get('config').get('tenantConfig'),
    configLoad: state.get('config').get('isLoad'),
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  callLoadSettingsAPI: (...params) => dispatch(loadSettings(...params)),
  callRegisterCandidateAPI: (...data) => dispatch(registerCandidate(...data)),
  CallUpdateCandidate: (...params) =>
    dispatch(updateCandidateDetails(...params)),
});

export default connect(mapStateProps, mapDispatchToProps)(Apply);
